export default __webpack_public_path__ + "static/media/placa-rede.3adcb739.png";